<template>
    <v-card class="finalize-dialog custom-dialog">
        <v-card-title>
            {{waiverDialogConstants.EMAIL_TEMPLATE}}
            <v-flex text-xs-right>
                <i class="fas fa-times" @click="closeDialog()" data-qe-id="closeFinalizeDialogBoxIcon"></i>
            </v-flex>
        </v-card-title>
        <v-card-text class="inner-scrollbar">
            <ck-editor
                :editor-id="ckEditorId"
                data-qe-id="finalize_txt_emailbody"
                :editor-type="ckEditorType.BASIC"
                v-model="emailBody"
                class="ck-editor__font pb-3">
            </ck-editor>
            <span class="finalize-dialog__label">{{waiverDialogConstants.SUBJECT}}</span>
            <v-text-field
                v-model="subject"
                readonly
                data-qe-id="finalize_txt_subject"> </v-text-field>
            <v-layout row wrap>
                <v-flex xs9 class="finalize-dialog__error">
                    <v-flex v-if="showError" data-qe-id="finalize_error_occured">{{chapterWaiverConstants.ERROR_OCCURRED}}</v-flex>
                </v-flex>
            </v-layout>
            <v-flex pb-3 class="relative-position">
                <span data-qe-id="finalizeEmail_to_Label" class="finalize-dialog__label">{{waiverDialogConstants.TO}}</span>
                <span class="finalize-dialog__chip" v-if="toList && toList.length > 0">
                    <v-chip
                        :data-qe-id="`finalizeEmail_toRecipient_${index}`"
                        v-for="(person, index) in toList"
                        :key="index"
                        close
                        clearable
                        @input="removeRecipients('toList', person.id)">
                        {{`${person.firstName} ${person.lastName}`}}
                    </v-chip>
                </span>
                <v-text-field
                    data-qe-id="finalize_txt_to"
                    v-model="toSearchToken"
                    @paste="searchToRecipients"
                    @keyup="searchToRecipients">
                </v-text-field>
                <v-flex class="finalize-dialog__result inner-scrollbar" v-if="showToResults">
                    <status-overlay :action="searchAction" v-if="toSearchToken.length > 2"></status-overlay>
                    <v-flex text-xs-center v-if="toSearchResults && toSearchResults.length < 1"> {{waiverDialogConstants.NO_RESULTS}}</v-flex>
                    <v-flex
                        :data-qe-id="`finalizeEmail_to_Search_Result_${index}`"
                        pointer
                        v-else
                        class="finalize-dialog__result--list"
                        :key="index"
                        v-for="(person, index) in toSearchResults"
                        @click="selectToRecipient(person)">
                        <img :data-qe-id="`finalizeEmail_to_Search_Result_profileImage_${index}`" :src="person.profileImageUrl" :onerror="imageErrorFallback(person.fallbackProfileImageUrl)">
                        <v-flex>
                            <strong :data-qe-id="`finalizeEmail_to_Search_Result_Name_${index}`">{{`${person.firstName} ${person.lastName}`}}</strong>
                            <span :data-qe-id="`finalizeEmail_to_Search_Result_PrimaryChapter_${index}`">{{person.primaryChapter}}</span>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
            <v-flex pb-3 class="relative-position">
                <span data-qe-id="finalizeEmail_cc_Label" class="finalize-dialog__label">{{waiverDialogConstants.CC}}</span>
                <span class="finalize-dialog__chip" v-if="ccList && ccList.length > 0">
                    <v-chip
                        :data-qe-id="`finalizeEmail_ccRecipient_${index}`"
                        v-for="(person, index) in ccList"
                        :key="index"
                        close
                        clearable
                        @input="removeRecipients('ccList', person.id)">
                        {{`${person.firstName} ${person.lastName}`}}
                    </v-chip>
                </span>
                <v-text-field
                    data-qe-id="finalize_txt_cc"
                    v-model="ccSearchToken"
                    @paste="searchCCRecipients"
                    @keyup="searchCCRecipients"> </v-text-field>
                <v-flex class="finalize-dialog__result inner-scrollbar" v-if="showCCResults">
                    <status-overlay :action="searchAction" v-if="ccSearchToken.length > 2"></status-overlay>
                    <v-flex text-xs-center v-if="ccSearchResults && ccSearchResults.length < 1"> {{waiverDialogConstants.NO_RESULTS}}</v-flex>
                    <v-flex
                        v-else
                        pointer
                        :data-qe-id="`finalizeEmail_cc_Search_Result_${index}`"
                        class="finalize-dialog__result--list"
                        :key="index"
                        v-for="(person, index) in ccSearchResults"
                        @click="selectCCRecipient(person)">
                        <img :data-qe-id="`finalizeEmail_cc_Search_Result_profileImage_${index}`" :src="person.profileImageUrl" :onerror="imageErrorFallback(person.fallbackProfileImageUrl)">
                        <v-flex>
                            <strong :data-qe-id="`finalizeEmail_cc_Search_Result_Name_${index}`">{{`${person.firstName} ${person.lastName}`}}</strong>
                            <span :data-qe-id="`finalizeEmail_cc_Search_Result_PrimaryChapter_${index}`">{{person.primaryChapter}}</span>
                        </v-flex>
                    </v-flex>
                </v-flex>
            </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-flex text-xs-right class="pt-2 pb-2 pl-1 pr-3">
                <v-btn
                    data-qe-id="cancelFinalizeDialogBoxBtn"
                    class="primary_btn transparent small"
                    @click="closeDialog()">{{actionConstants.CANCEL}}</v-btn>
                <v-btn
                    :loading="updateInProgress"
                    data-qe-id="submit_finalize_btn"
                    class="primary_btn small"
                    :disabled="isSubmitDisabled"
                    @click="confirmAndDeny()">{{actionConstants.SUBMIT}}</v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { appCommonConstants } from "../appCommon.constants";
    import { chapterWaiverConstants, waiverFormConstants, waiverFormTypesConstants, actionConstants, finalizeWaiverBody, waiverDialogConstants } from "./ChapterWaiver.constants";
    import { mapGetters, mapActions, mapState } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { getRandomId, imageErrorFallback } from "../../common/utils/utils";
    import CkEditor from "../CkEditor/CkEditor";
    import { ckEditorType } from "../../plugins/CkEditor/ckEditorTypes.config";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';

    export default {
        name: 'FinalizeWaiverDialog',
        created() {
            this.denyReasonText = '';
            this.getFinalizeEmailRecipients(this.leadDetails.targetChapter)
                .then(() => {
                    this.getwaiverFlowStatus();
                });
            if (this.waiverFlowStatus === this.chapterWaiverConstants.APPROVED) {
                this.emailBody = this.finalizeWaiverBody.APPROVE_WAIVER;
            } else {
                this.emailBody = this.finalizeWaiverBody.DENY_WAIVER;
            }
        },
        components: {
            CkEditor,
            StatusOverlay,
        },
        data: () => {
            return {
                appCommonConstants,
                waiverFormTypesConstants,
                chapterWaiverConstants,
                waiverFormConstants,
                waiverDialogConstants,
                actionConstants,
                finalizeWaiverBody,
                showError: false,
                updateInProgress: false,
                ckEditorId: getRandomId(),
                ckEditorType,
                emailBody: null,
                toList: null,
                ccList: null,
                subject: null,
                finalizeWaiverRequestData: {
                    toList: [],
                    ccList: [],
                },
                toSearchToken: '',
                ccSearchToken: '',
                showToResults: false,
                showCCResults: false,
                toSearchResults: [],
                ccSearchResults: [],
            };
        },
        props: {
            closeDialog: {
                type: Function,
                required: true,
            },
            leadDetails: {
                type: Object,
                required: true,
            },
            waiverFlowStatus: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapGetters({
                finalizeEmailRecipients: `chapterWaiver/${storeGetters.finalizeEmailRecipients}`,
                finalizeError: `chapterWaiver/${storeGetters.finalizeError}`,
            }),
            isSubmitDisabled() {
                return this.emailBody === null || this.emailBody === '' || (this.toList && this.toList.length < 1);
            },
            searchAction() {
                return this.actions[storeAction.searchUsersForFinalizeMail];
            },
            ...mapState("actionState", ["actions"]),
        },
        methods: {
            imageErrorFallback,
            ...mapActions({
                getFinalizeEmailRecipients: `chapterWaiver/${storeAction.getFinalizeEmailRecipients}`,
                finalizeWaiverRequest: `chapterWaiver/${storeAction.finalizeWaiverRequest}`,
                searchUsersForFinalizeMail: `chapterWaiver/${storeAction.searchUsersForFinalizeMail}`,
            }),
            getwaiverFlowStatus() {
                this.subject = `${this.waiverDialogConstants.WAIVER_FOR} ${this.leadDetails.firstName} ${this.leadDetails.lastName} (${this.leadDetails.chapterName}) ${this.waiverDialogConstants.HAS_BEEN} ${this.waiverFlowStatus}`;
            },
            async confirmAndDeny() {
                this.updateInProgress = true;
                this.finalizeWaiverRequestData.toList = this.toList;
                this.finalizeWaiverRequestData.ccList = this.ccList;
                this.finalizeWaiverRequestData = {
                    ...this.finalizeWaiverRequestData,
                    emailContent: this.emailBody,
                    finalizeStatus: this.waiverFlowStatus,
                    leadId: this.leadDetails.id,
                    subject: this.subject,
                };
                const leadInfo = {
                    waiverFlowStatus: this.waiverFlowStatus,
                    waiverStatus: this.waiverFlowStatus,
                    leadId: this.leadDetails.id,
                };
                const param = {
                    finalize: this.finalizeWaiverRequestData,
                    leadDetails: leadInfo,
                };
                await this.finalizeWaiverRequest(param);
                this.showError = this.finalizeError;
                if (this.finalizeError) {
                    setTimeout(() => {
                        this.showError = false;
                        this.updateInProgress = false;
                    }, 6000);
                } else {
                    this.updateInProgress = false;
                    this.closeDialog();
                }
            },
            removeRecipients(listType, id) {
                if (listType === 'toList') {
                    this.toList = this.toList.filter((x) => {
                        return x.id !== id;
                    });
                    return;
                }
                this.ccList = this.ccList.filter((x) => {
                    return x.id !== id;
                });
            },
            async searchToRecipients() {
                if (this.toSearchToken.length < 3) {
                    this.showToResults = false;
                    this.toSearchResults = [];
                    return;
                }
                this.showToResults = true;
                this.toSearchResults = await this.searchRecipients(this.toSearchToken);
            },
            async searchRecipients(token) {
                const ser = this.searchUsersForFinalizeMail(token).then((res) => {
                    return res.data.map((x) => {
                        return {
                            id: x.id,
                            firstName: x.firstName,
                            lastName: x.lastName,
                            gender: x.gender,
                            email: x.email,
                            profileImageUrl: x.profileImageUrl,
                            fallbackProfileImageUrl: x.fallbackProfileImageUrl,
                            primaryChapter: x.primaryChapter,
                        };
                    });
                });
                return ser;
            },
            selectToRecipient(person) {
                const user = this.getUser(person);
                this.toList.push(user);
                this.toSearchToken = '';
                this.showToResults = false;
            },
            getUser(person) {
                return {
                    id: person.id,
                    firstName: person.firstName,
                    lastName: person.lastName,
                    gender: person.gender,
                    email: person.email,
                };
            },
            selectCCRecipient(person) {
                const user = this.getUser(person);
                this.ccList.push(user);
                this.ccSearchToken = '';
                this.showCCResults = false;
            },
            async searchCCRecipients() {
                if (this.ccSearchToken.length < 3) {
                    this.showCCResults = false;
                    this.ccSearchResults = [];
                    return;
                }
                this.showCCResults = true;
                this.ccSearchResults = await this.searchRecipients(this.ccSearchToken);
            },
        },
        watch: {
            finalizeEmailRecipients(val) {
                this.ccList = [];
                this.toList = [];
                this.finalizeWaiverRequestData.toList = val.toList;
                this.finalizeWaiverRequestData.ccList = val.ccList;
                val.ccList.forEach((rec) => {
                    this.ccList.push(rec);
                });
                val.toList.forEach((rec) => {
                    this.toList.push(rec);
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";

    .error {
        color: $ypo-deep-red;
    }

    .finalize-dialog {
        &.custom-dialog {

            .v-card {
                &__text {
                    margin: 0px;
                    padding: 16px 16px 16px 16px;
                }
            }

            .v-card__title {
                color: $white;
                background: $ypo-blue;
                font-size: 19px;

                i {
                    color: $white;
                    padding: 2px 2px 0px 25px;
                    cursor: pointer;
                }
            }

        }

        &__error {
            color: $ypo-deep-red;
        }

        &__result {
            background-color: $white;
            border: 1px solid rgba($black, 0.5);
            position: absolute;
            width: 100% !important;
            min-height: 100px;
            z-index: 3;
            padding: 10px 0;
            border-radius: 0 0 3px 3px;
            margin-top: -8px;
            max-height: 200px;
            overflow-y: auto;

            &--list {
                position: relative;
                padding: 10px 10px 10px 70px;
                align-items: center;
                transition: 0.3s all ease;
                min-height: 62px;
                align-items: center;
                display: flex;

                &:hover {
                    background-color: rgba($ypo-gray, 0.3);
                }

                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    position: absolute;
                    left: 10px;
                    top: 6px;
                }

                strong,
                span {
                    display: block;
                }

                span {
                    font-size: 12px;
                }
            }
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import '../../common/styles/responsive.scss';

    .finalize-dialog {

        .v-input__slot:before,
        .v-input__slot:after {
            display: none;
        }

        .v-text-field {
            padding: 0px;
            margin: 0px;
        }

        .v-messages {
            display: none;
        }

        .v-input input {
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
            border-bottom: 1px solid $ypo-medium-gray;
            font-size: 14px;
            opacity: 0.8;
            @include breakpoint(xs) {
                font-size: 12px;
            }
        }

        &__label {
            font-weight: 600;
            color: $ypo-blue;
        }

        &__chip {
            .v-chip__content {
                background-color: rgba($black, 0.7);
                color: $white;

                .v-icon {
                    opacity: inherit;
                }
            }
        }

        .ck-editor .cke {
            border: 1px solid $ypo-medium-gray;
            border-top: none;

        }

        .cke_contents {
            padding: 0 10px;
        }

    }
</style>
